import React, {FC} from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import {useIntl} from "@irati/utils/lang"
import {triggerSuccessToast} from "../ToastAlert/triggerSuccessToast"
import {StyledIconButton} from "./styled"
import {IconTypes} from "@irati/ui/src/Icon"

interface SharingData {
  title: string
  url: string
}

interface Props {
  onClick: (e: any) => void
  copyText: string
  sharingData: SharingData
  icon?: string
  iconSize?: number
}

const ShareIconButton: FC<Props> = ({onClick, sharingData, copyText, icon = IconTypes.share, iconSize = 24}) => {
  const {formatMessage} = useIntl()

  const handleCopyClick = (event: any) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    triggerSuccessToast(formatMessage({id: "platform.shareToDrawer.toast"}))
  }

  if (navigator.canShare && navigator.canShare(sharingData)) {
    return <StyledIconButton icon={icon} size={iconSize} onClick={onClick} />
  }
  return (
    <CopyToClipboard text={copyText}>
      <StyledIconButton icon={icon} size={iconSize} onClick={handleCopyClick} />
    </CopyToClipboard>
  )
}

export default ShareIconButton
